module.exports = __webpack_public_path__ + "static/media/signup_image.6a8868a9.png";